import React from 'react';
import ConversationView from './ConversationView';
import AllConversationView from './AllConversationView';
import MessageWidgetCard from './MessageWidgetCard';
import { useSelector } from 'react-redux';
import { selectorsResponsive } from '@app/store/conversations';
import { currentUserId } from '@core/selectors/user';
import { conversationLatestMessage } from '@core/conversations/selectorsResponsive';
import { mutedConversations } from '@core/notifications/selectors';

const MessagesWidget = () => {
  const [isConversationDialogOpen, setIsConversationDialogOpen] =
    React.useState(false);
  const [isAllConversationsDialogOpen, setIsAllConversationsDialogOpen] =
    React.useState(false);

  const handleConversationClick = (conversationId: string) => {
    setIsConversationDialogOpen(true);
    window.location.href = `/#/home/messages/${conversationId}`;
  };

  const handleConversationDialogClose = () => {
    setIsConversationDialogOpen(false);
    window.location.href = `/#/home`;
  };

  const conversations = useSelector(selectorsResponsive.paginatedConversations);
  const userId = useSelector(currentUserId);
  const totalUnreadCount = useSelector((state: any) => {
    if (!userId) return 0;
    return conversations.filter((conversation: any) => {
      const isUnread =
        selectorsResponsive.isConversationUnreadBy &&
        selectorsResponsive.isConversationUnreadBy(
          state,
          conversation.id,
          userId
        );
      if (!isUnread) return false;
      // Only count as unread if the latest message was NOT sent by current user
      const latestMessage = conversationLatestMessage(state, conversation.id);
      return latestMessage?.writer !== userId;
    }).length;
  });
  const mutedConversation = useSelector(mutedConversations);

  return (
    <>
      <MessageWidgetCard
        setIsAllConversationsDialogOpen={setIsAllConversationsDialogOpen}
        handleConversationClick={handleConversationClick}
        conversations={conversations}
        totalUnreadCount={totalUnreadCount}
        mutedConversation={mutedConversation}
      />

      <ConversationView
        isConversationDialogOpen={isConversationDialogOpen}
        handleConversationDialogClose={handleConversationDialogClose}
      />

      <AllConversationView
        isAllConversationsDialogOpen={isAllConversationsDialogOpen}
        setIsAllConversationsDialogOpen={setIsAllConversationsDialogOpen}
        handleConversationClick={handleConversationClick}
        conversations={conversations}
        totalUnreadCount={totalUnreadCount}
        mutedConversation={mutedConversation}
      />
    </>
  );
};

export default MessagesWidget;
